import { NO_RESET_OPTION_FILTERS, SEARCH_TYPES, SINGLE_OPTION_FILTERS, SORT_TYPES } from './filtersTypes';
import { SORT_BY_MY_PLAYLISTS, SORT_BY_MY_PLAYLISTS_NO_SEARCH } from '../../constants/TopFilterConstants';
import { FilterItems } from './FilterItems';
export const getFilterItems = ({
  filterType,
  searchFilter,
  canFilterContentTypeByPlaylist
}) => {
  switch (filterType) {
    case 'sortByMyPlaylists':
      // sort on my playlists has different options depending on the search input
      return searchFilter ? SORT_BY_MY_PLAYLISTS : SORT_BY_MY_PLAYLISTS_NO_SEARCH;
    case 'contentType':
      if (!canFilterContentTypeByPlaylist) {
        return FilterItems[filterType].filter(item => item !== 'LEARNING_PATH');
      }
      break;
    default:
  }
  return FilterItems[filterType] || [];
};
export const isSearchFilter = filter => SEARCH_TYPES.includes(filter);
export const isSortFilter = filter => SORT_TYPES.includes(filter);
export const isSingleOptionFilter = filter => SINGLE_OPTION_FILTERS.includes(filter);
export const isNoResetOptionFilter = filter => NO_RESET_OPTION_FILTERS.includes(filter);